import React from "react";
import { Select } from "antd";
import { useCrm } from "./CrmDropdown.tsx";
import { useAds } from "./AdsDropdown.tsx";
import { useAiv } from "./aivListDropdown.tsx";
import { usePostHog } from "posthog-js/react";
import ConnectionDropdownIcon from '../assets/svg/connectionDropdownIcon.svg'

const CombinedDropdown: React.FC = () => {
  const { selectedCrm, setSelectedCrm, options: crmOptions } = useCrm();
  const { selectedAds, setSelectedAds, options: adsOptions } = useAds();
  const { selectedList, setSelectedList, options: aivOptions } = useAiv();
  const posthog = usePostHog();
  const value = selectedCrm ?? selectedAds ?? selectedList;

  const handleChange = (val: string | undefined) => {
    
    if (!val) {
      setSelectedCrm(undefined);
      setSelectedAds(undefined);
      setSelectedList(undefined);
      return;
    }

    if (crmOptions.some((opt) => opt.value === val)) {
      setSelectedCrm(val);
      setSelectedAds(undefined);
      setSelectedList(undefined);
    } else if (adsOptions.some((opt) => opt.value === val)) {
      setSelectedAds(val);
      setSelectedCrm(undefined);
      setSelectedList(undefined);
    } else if (aivOptions.some((opt) => opt.value === val)) {
        setSelectedList(val);
      setSelectedCrm(undefined);
      setSelectedAds(undefined);
    } else {
      setSelectedCrm(undefined);
      setSelectedAds(undefined);
      setSelectedList(undefined);
    }
  };

  const groupedOptions = [
    { label: "CRM", options: crmOptions.filter(option =>(option.crm !== 'webhook')) },
    { label: "Webhook", options: crmOptions.filter(option =>(option.crm === 'webhook')) },
    { label: "Ads", options: adsOptions },
    { label: "AIV", options: aivOptions },
  ];

  return (
    <Select
      className="ConnectionDropdownSelect"
      prefix={<ConnectionDropdownIcon/>}
      dropdownStyle={{width: '50vh'}}
      allowClear
      options={groupedOptions}
      value={value}
      onChange={(e) => {
        posthog.capture('dropdown_list_to_send_select');
        handleChange(e);
      }}
      showSearch
      filterOption={(input, option) =>
        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
      }
    />
  );
};

export default CombinedDropdown;
